module.exports={
	"Form": "ContractTypeViewManifest",
	"Scope": "ContractType-View",
	"Descriptors":
	{
		"ContractTypeDetails.IDContractType":
		{
			"Name": "ID",
			"Hash": "ContractTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.GUIDContractType":
		{
			"Name": "GUID",
			"Hash": "ContractTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 8,
				"Section": "ContractTypeIdentity",
				"Group": "ContractTypeIdentity"
			}
		},
		"ContractTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ContractTypeView-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a contract of this type can occupy.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.AllowedProjectTypeNamesText":
		{
			"Name": "Allowed Project Types",
			"Hash": "ContractTypeView-AllowedProjectTypeNames",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.DefaultDatesText":
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeView-DefaultDates",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeSettings",
				"Group": "ContractTypeSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.PrototypeContractName":
		{
			"Name": "Prototype Contract",
			"Hash": "ContractTypeView-PrototypeContractName",
			"DataType": "String",
			"Description": "The canonical prototype contract an admin configures for this contract type; cloned onto real contracts of this type.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypePrototype",
				"Group": "ContractTypePrototype"
			}
		},
		"ContractTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ContractTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ContractTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ContractTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		},
		"ContractTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ContractTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ContractTypeAudit",
				"Group": "ContractTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ContractTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ContractTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ContractTypeSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ContractTypeSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Prototype Contract",
			"Hash": "ContractTypePrototype",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Prototype Contract",
					"Hash": "ContractTypePrototype",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ContractTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ContractTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
